import React from "react";

export default function IconFacebook() {
	return (
		<a href="https://www.facebook.com/Uloz-doklad-103839824723522" target="_blank" rel="noopener noreferrer">
			<img src="/fb.svg" alt="FB" />
		</a>
	);
}
